// extracted by mini-css-extract-plugin
export var notificationButton = "NotificationEmailSection-module__notificationButton___8nMSx";
export var notificationEmail = "NotificationEmailSection-module__notificationEmail___3F9Ai";
export var notificationError = "NotificationEmailSection-module__notificationError___upIMM";
export var notificationInput = "NotificationEmailSection-module__notificationInput___jE+X6";
export var notificationLabel = "NotificationEmailSection-module__notificationLabel___pCjKZ";
export var notificationSection = "NotificationEmailSection-module__notificationSection___t7XtM";
export var unverifiedBadge = "NotificationEmailSection-module__unverifiedBadge___WB9ii";
export var verifiedBadge = "NotificationEmailSection-module__verifiedBadge___yvSBX";